export default {
    stocks: [],
    totalDataRow:0 
}
  